import { render } from "./AvoidingRenderingBouncing.vue?vue&type=template&id=53c00ca4"
import script from "./AvoidingRenderingBouncing.vue?vue&type=script&lang=ts"
export * from "./AvoidingRenderingBouncing.vue?vue&type=script&lang=ts"
script.render = render

export default script